import { jsxs as n, jsx as m } from "react/jsx-runtime";
import { Stack as s, Typography as c } from "@mui/material";
import "../../queries/message/index.js";
import "../../queries/contact/index.js";
import "../../queries/calendars/index.js";
import "../../pointsGraph-DTJju-rA.js";
import "../../queries/student/index.js";
import "../../queries/settings/index.js";
import "../../queries/points/index.js";
import "../../queries/assessment/index.js";
import "../../queries/assessment/annotations/index.js";
import "../../queries/assessment/rubrics/index.js";
import "../../queries/assessment/qcesubjects/index.js";
import "../../queries/assessment/extensionrequest/index.js";
import "../../queries/files/index.js";
import "../../queries/attendance/index.js";
import "../../queries/forms/index.js";
import "../../queries/notifications/index.js";
import "../../queries/interviews/index.js";
import { notes as f } from "../../queries/notes/index.js";
import "../../queries/annoucements/index.js";
import "../../queries/payments/index.js";
import "../../queries/assessment/analysis/index.js";
import "../../queries/group/index.js";
import "../../queries/projects/index.js";
import "../../queries/courses/index.js";
import "../../queries/password/index.js";
import { LessonPlanItem as I } from "../list/components/lessonPlan.js";
import { NoteItem as a } from "../list/components/note.js";
const K = ({ plans: t, studentId: i, eventId: p }) => {
  if (!t || t.length === 0)
    return null;
  const { data: r, isPending: e } = new f.NotesForEvent({ eventId: p ?? 0, studentId: i ?? 0 }).ToQuery();
  return /* @__PURE__ */ n(s, { spacing: 1, children: [
    /* @__PURE__ */ m(c, { variant: "h3", children: "Notes" }),
    t.map((o) => /* @__PURE__ */ m(I, { ...o }, o.NoteID)),
    !e && (r == null ? void 0 : r.map((o) => /* @__PURE__ */ m(a, { ...o }, o.ID)))
  ] });
};
export {
  K as LessonPlans
};
//# sourceMappingURL=LessonPlans.js.map
